import { cartMobx, orderMobx, restaurantConfig, storeMobx, productCenter, restaurantCenter, orderListMobx, deskMobx } from 'restaurant'
import { store, ddayjs, setCookie, getCookie, getParams } from '@dt/fe-utils'
import { ConfirmModal } from '@cps'
import checkoutPayController from 'controllers/checkoutPayController'
import { modalLayer, getHistoryNew, getPlatform } from '@utils'
import { multiPersonMobx, memberMobx } from '@mobxStore'
import { OrderEnterTableConfirmModal } from '@pages/menu/modal'
import { filter, minBy, some } from '@dt/fe-utils/dist/lodash'

let orderEnterTableFlag = false

class RestoreOrderController {
  private static isThisTime = false
  static localKey (type: 'brand' | 'store' | 'prefix' = 'store') {
    let _key = 'order.pendingOrdersId'
    if (cartMobx.posOrderPay) {
      _key = 'posOrder.pendingOrdersId'
    }
    if (type === 'prefix') {
      return _key
    }
    if (type === 'brand') {
      return `${_key}.${restaurantConfig.brandId || Config.BRANDID}`
    }
    return `${_key}.${restaurantConfig.brandId || Config.BRANDID}.${restaurantConfig.storeId || Config.STOREID}`
  }
  static async restore (fromPayfail: boolean = false) {
    if (this.isThisTime) {
      return
    }
    this.isThisTime = true
    const pendingOrdersId = !cartMobx.info.payMode ? store.get(this.localKey()) : ''
    let fetchOrder = null
    if (!pendingOrdersId) {
      try {
        // TODO 支持获取订单详情
        const order = restaurantConfig.codeType === 'table' && storeMobx.info.openMultiPersonOrdering ? await orderListMobx.getFirstTabelCodeOrder(restaurantConfig.tableCode.toString()) : await orderListMobx.getFirstPayingOrder()
        if (order) {
          fetchOrder = order
        }
      } catch (error) {
      }
    }
    if (!pendingOrdersId && !fetchOrder) {
      return
    }
    // 需要先清除原先的购物车的数据确保 购物车当前没数据
    cartMobx.safeClear()
    await cartMobx.setOrdersId(fetchOrder ? fetchOrder.ordersId : pendingOrdersId)
    if (orderMobx.order?.ordersType !== 'dc') {
      await orderMobx.reset()
      await cartMobx.reset()
      this.clearHold()
      return
    }
    const order = orderMobx.viewOrder
    // 判断当前这个订单是否可用
    if (order.status === 'Pending' || order.status === 'Paying' || order.status === 'NotAccepted') {
      const history = getHistoryNew()
      // 如果不在点餐页、支付失败页
      if (!fromPayfail && history.location.pathname !== '/menu') {
        return
      }
      if (!fromPayfail && order.paymentList.length > 0) {
        history.push(`/result/${order.ordersId}`)
        return
      }
      if (restaurantConfig.codeType === 'table' && storeMobx.info.openMultiPersonOrdering) {
        /** 换桌号重置购物车 */
        if (order.tableCode && Config.TABLECODE && order.tableCode.toString() !== Config.TABLECODE.toString()) {
          cartMobx.reset(cartMobx.info.payMode, cartMobx.info.eatType)
          cartMobx.setTableCode(Config.TABLECODE)
          orderMobx.reset()
          this.clearHold()
          return
        }
        /** 先付费支付失败还原 */
        if (fromPayfail && !cartMobx.info.payMode) {
          cartMobx.restoreOrderToCart()
        }
        /** 如果当前游客没有登录，忽略 */
        if (!multiPersonMobx.getCurrentPersonInfo()?.personId) {
          return
        } else if (order.status === 'NotAccepted') {
          // orderLiveMobx.pollOrderStaus(order.ordersId)
          !fromPayfail && history.push('/checkout')
        } else if (orderMobx.viewDetailList.length) {
          !fromPayfail && history.push('/checkout')
        }
      } else {
        modalLayer.closeAll()
        if (fromPayfail) {
          this.checkout(fromPayfail)
          return
        }
        return modalLayer(ConfirmModal, {
          title: i18n.t('common.attention'),
          confirmText: i18n.t('menu.go_pay'),
          canClose: false,
          backdropDismiss: false,
          children: i18n.t('menu.you_has_unpay_bill', { price: order.paidFee }),
          cancelText: i18n.t('menu.continue_shop'),
          className: 'cart-confirm-modal'
        }, 'restoreOrderModal').then((res: any) => {
          store.remove(this.localKey())
          this.checkout()
        }).catch(async (res: any) => {
          if (res) {
            store.remove(this.localKey())
            cartMobx.reset(cartMobx.info.payMode, cartMobx.info.eatType)
          } else {
          // do nothing
          }
          // 关闭等待支付的订单
          if (order.status === 'Paying') {
            await checkoutPayController.resume(order.ordersId)
          }
          orderMobx.cancel()
        })
      }
    } else {
      // 如果订单无效也需要清理掉订单中的数据
      orderMobx.reset()
      cartMobx.clearOrdersId()
      this.clearHold()
    }
  }
  static hold (ordersId) {
    store.set(this.localKey(), ordersId)
    this.tempHold(ordersId)
    this.isThisTime = true
  }
  static clearHold () {
    store.remove(this.localKey())
  }
  static async checkout (fromPayfail: boolean = false) {
    const history = getHistoryNew()
    if (orderMobx.order.ordersId) {
      // 关闭等待支付的订单
      if (orderMobx.order.status === 'Paying') {
        checkoutPayController.resume(orderMobx.order.ordersId)
      }
      // 还原门店
      if (orderMobx.order.storeId !== productCenter.storeId) {
        const viewStore = storeMobx.viewStoreList.find(store => store.storeId === orderMobx.order.storeId)
        if (viewStore) {
          storeMobx.initInfo(viewStore)
        }
        // 还原菜单
        if (!productCenter.storeId || productCenter.storeId !== restaurantConfig.storeId) {
          restaurantCenter.init()
        }
      }
      if (orderMobx.order.payMode) {
        cartMobx.setOrder()
      } else {
        cartMobx.restoreOrderToCart()
      }
      !fromPayfail && history.push('/checkout')
    }
  }
  static tempHold (ordersId) {
    const { isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()
    if (isWeixinMiniProgram || isAliPayMiniProgram) {
      setCookie(this.localKey('brand'), ordersId, Date.now() + 60000)
    }
  }
  static getTempHold () {
    return getCookie(this.localKey('brand'))
  }
  /** 提醒订单录桌 */
  static async orderEnterTable () {
    if (orderEnterTableFlag || !storeMobx.info.storeId) return
    const history = getHistoryNew()
    const { webviewLoaded } = getParams()
    const list = await orderListMobx.memberNeedTablelist(memberMobx?.memberInfo?.memberId)
    if (list?.length && !webviewLoaded) {
      const _list = filter(list, i => some(i.detailList, d => {
        const _val = ddayjs(d.startTime).valueOf()
        return _val > ddayjs().startOf('day').valueOf() && _val < ddayjs().endOf('day').valueOf()
      }))?.filter(item => item.extList?.find(ext => ext.attrName === 'scanType')?.attrValue === 'brand')
      const order = minBy(_list, i => {
        const s = minBy(i.detailList, (d: any) => Math.abs(ddayjs(d.startTime).valueOf() - ddayjs().valueOf()))
        return Math.abs(ddayjs(s.startTime).valueOf() - ddayjs().valueOf())
      })
      if (order) {
        orderEnterTableFlag = true
        modalLayer.closeAll()
        if (['brand', 'store'].includes(Config.codeType)) {
          history.push(`/result/${order.ordersId}`)
        } else if (Config.codeType === 'table') {
          const pics = order.pics?.length ? order.pics.map(item => {
            try {
              return item ? JSON.parse(item)[0]?.url : ''
            } catch (error) {
              return item
            }
          }) : []
          return modalLayer(OrderEnterTableConfirmModal, { pics: pics.slice() }, 'orderEnterTableModal').then(async () => {
            const tableCode = Config.TABLECODE
            if (!deskMobx.tableCodeToTableAliasMap[tableCode]) await deskMobx.init(storeMobx.info.storeId)
            await orderMobx.createTable({
              ordersId: order.ordersId,
              tableCode: tableCode,
              tableAlias: deskMobx.tableCodeToTableAliasMap[tableCode]
            })
            history.push(`/result/${order.ordersId}`)
          })
        }
      }
    }
  }
  static setOrderEnterTableFlag () {
    orderEnterTableFlag = true
  }
}

export default RestoreOrderController
